import createIcon from '../../createIcon';

/**
 * @component @name PregnantWoman
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA0QzkgMi44OSA5Ljg5IDIgMTEgMkMxMi4xMSAyIDEzIDIuODkgMTMgNEMxMyA1LjExIDEyLjExIDYgMTEgNkM5Ljg5IDYgOSA1LjExIDkgNFpNMTYgMTNDMTUuOTkgMTEuNjYgMTUuMTcgMTAuNDkgMTQgMTBDMTQgOC4zNCAxMi42NiA3IDExIDdDOS4zNCA3IDggOC4zNCA4IDEwVjE3SDEwVjIySDEzVjE3SDE2VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PregnantWoman = createIcon('PregnantWoman', [
  [
    'path',
    {
      d: 'M9 4C9 2.89 9.89 2 11 2C12.11 2 13 2.89 13 4C13 5.11 12.11 6 11 6C9.89 6 9 5.11 9 4ZM16 13C15.99 11.66 15.17 10.49 14 10C14 8.34 12.66 7 11 7C9.34 7 8 8.34 8 10V17H10V22H13V17H16V13Z',
      key: 'mvxfdq',
    },
  ],
]);

export default PregnantWoman;
